// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-57d4180d]{width:100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.error[data-v-57d4180d]{font-size:40px}.message[data-v-57d4180d]{margin-bottom:40px}.message-btn[data-v-57d4180d]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
